import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Table, Alert, Box } from '@pocketlaw/tetris';
import { SearchResultTableBody } from './SearchResultsTableBody';
import { SearchResultsTableHead } from './SearchResultsTableHead';
import { TableContext } from './TableContext';
import { useSelected } from './useSelected';
import { useSearchContext } from '../SearchProvider';
import { SearchResultsNoMatch } from '../SearchResultsNoMatch';
import { SearchResultsPagination } from '../SearchResultsPagination';
import { SearchTableColumnToggle } from '../SearchTableColumnToggle';
import { TableContainer } from './styled';
export function SearchResultsTable(props) {
    const { results = [], loading, error, totalHitsCount = 0, actions, filters, dense = false, withoutBorder = false, } = props;
    const [selected, setSelected] = useSelected(results);
    const { values, setOrderBy } = useSearchContext();
    const [activeAction, setActiveAction] = useState();
    const { orderBy, limit, columns } = values;
    const [sortId, sortOrder] = orderBy ? Object.entries(orderBy)[0] : [];
    const resultCount = results.length;
    const noResults = resultCount === 0 && !loading;
    const hasBulkActions = Boolean(actions);
    const loadingColumns = columns.filter((col) => col.active).length;
    const handleSort = (newSortId, newSortState) => {
        if (newSortId) {
            setOrderBy({ [newSortId]: newSortState });
        }
    };
    if (error) {
        return (<Alert appearance="danger" message={t({
                message: 'Something went wrong, please try again later',
                comment: 'Error alert message',
            })}/>);
    }
    return (<TableContext.Provider value={{
            activeAction,
            setActiveAction,
            selected,
            setSelected,
            results,
            actions: hasBulkActions,
        }}>
      <TableContainer>
        <Box gap="lg" alignItems="center">
          {filters}
          <Box ml="auto" gap="sm" alignSelf="flex-end">
            <SearchResultsPagination disabled={loading} totalCount={totalHitsCount} limit={limit}/>
            <SearchTableColumnToggle />
          </Box>
        </Box>

        {noResults && <SearchResultsNoMatch />}

        {!noResults && (<Table border={!withoutBorder} dense={dense} sortId={sortId} sortOrder={sortOrder} onSort={handleSort} loading={loading} loadingColumns={loadingColumns} loadingRows={limit}>
            <SearchResultsTableHead />
            <SearchResultTableBody />
          </Table>)}

        {actions}
      </TableContainer>
    </TableContext.Provider>);
}
